module.exports = __webpack_public_path__ + "img/5_98.a687bb52.png";